<template>
    <div class="table-n-previews">
        <div class="table-n-previews__table-wrap">
            <div class="title-block">
                <div class="title-block__title">Контент</div>
                <div class="content-btn-group" role="group">
                    <button type="button" class="btn-primary btn dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                        {{ $trans('ru.globals.Add') }}
                    </button>

                    <a class="title-block__btn btn-outline-primary btn" href="#" @click.prevent="addModalIsOpen = true">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.6668 8.66634H8.66683V12.6663H7.3335V8.66634H3.3335V7.33301H7.3335V3.33301H8.66683V7.33301H12.6668V8.66634Z" fill="currentColor"/>
                        </svg>
                        <span>Создать папку</span>
                    </a>

                    <ul class="dropdown-menu">
                        <li>
                            <a class="dropdown-item" :href="route_create_page">Добавить контент</a>
                        </li>
                        <li>
                            <a class="dropdown-item" @click.prevent="addContents">{{ $trans('ru.globals.AddFilesToFolder') }}</a>
                        </li>
                    </ul>
                </div>

                <a style="margin-left: auto;" class="title-block__btn btn-info-link__no-border btn" href="https://docs.d-services.ru/docs/admin/ds-adminka-ustroistv/1/adminka-ustroistv-cms/texniceskie-trebovaniia-dlia-reklamnyx-mediafailov">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_4550_53395)">
                            <path d="M2.5 9.99902C2.5 10.9839 2.69399 11.9592 3.0709 12.8691C3.44781 13.7791 4.00026 14.6059 4.6967 15.3023C5.39314 15.9988 6.21993 16.5512 7.12987 16.9281C8.03982 17.305 9.01509 17.499 10 17.499C10.9849 17.499 11.9602 17.305 12.8701 16.9281C13.7801 16.5512 14.6069 15.9988 15.3033 15.3023C15.9997 14.6059 16.5522 13.7791 16.9291 12.8691C17.306 11.9592 17.5 10.9839 17.5 9.99902C17.5 8.0099 16.7098 6.10225 15.3033 4.69572C13.8968 3.2892 11.9891 2.49902 10 2.49902C8.01088 2.49902 6.10322 3.2892 4.6967 4.69572C3.29018 6.10225 2.5 8.0099 2.5 9.99902Z" stroke="#0678F4" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M10 7.49902H10.0083" stroke="#0678F4" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M9.17188 10H10.0052V13.3333H10.8385" stroke="#0678F4" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_4550_53395">
                                <rect width="20" height="20" fill="white"/>
                            </clipPath>
                        </defs>
                    </svg>
                    <span>Технические требования</span>
                </a>

                <input class="d-none" type="file" ref="file_upload" v-on:change="fileUploads" accept=".jpg, .mp4" multiple>
            </div>

            <div class="filter-table">
                <div class="filter-table__input-wrap search-control">
                    <input v-model="search" type="text" class="search-control__input form-control" placeholder="Поиск">
                    <button class="search-control__input-btn reset-btn">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.5 8.333a5.834 5.834 0 1011.667 0 5.834 5.834 0 00-11.667 0zM17.5 17.5l-5-5"
                                stroke="currentColor" stroke-width="1.667" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </button>
                </div>

                <div class="filter-table__list-wrap">
                    <ul class="filter-table__list">
                        <li class="filter-table__item">
                            <v-select
                                id="client_id"
                                label="Клиент"
                                v-model="filter.client_id"
                                :items="clients"
                                item-title="name"
                                item-value="id"
                                variant="outlined"
                                color="primary"
                                density="compact"
                                clearable
                                @update:menu="$removeFocus"
                                @click:clear="$removeFocus"
                                @click:control="$removeFocus">
                                <template #no-data>
                                    <v-list-item>
                                        <span>Данные не найдены</span>
                                    </v-list-item>
                                </template>
                            </v-select>
                        </li>

                        <li class="filter-table__item">
                            <v-select
                                id="client_id"
                                label="Бренд"
                                v-model="filter.brand_id"
                                :items="brands"
                                item-title="name"
                                item-value="id"
                                variant="outlined"
                                color="primary"
                                density="compact"
                                clearable
                                @update:menu="$removeFocus"
                                @click:clear="$removeFocus"
                                @click:control="$removeFocus">
                                <template #no-data>
                                    <v-list-item>
                                        <span>Данные не найдены</span>
                                    </v-list-item>
                                </template>
                            </v-select>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="content-table-responsive">
                <content-table-component
                    v-if="this.items !== 'choose_client'"
                    ref="contentTable"
                    @addToDir="contentToDir"
                    @findElement="findElement"
                    @contentDir="loadDir">
                </content-table-component>
                <div v-else>{{ $trans('ru.globals.SelectAClient') }}!</div>
            </div>

            <pagination-element :count="count" :current_page="page" @pageChange="pageChange"></pagination-element>

            <content-picture-component
                v-if="showPic"
                :path="item.path"
                :name="item.name"
                :domain="domain"
                @closePicture="closeModal">
            </content-picture-component>
        </div>

        <div class="d-xl-block">
            <Transition name="fade">
                <content-info-component
                    v-if="selectedItem.id > 0"
                    @closeInfo="closeInfo"
                    :domain="domain">
                </content-info-component>
                <div v-else class="content-preview">
                    Загрузка...
                </div>
            </Transition>
        </div>
    </div>

    <Transition name="fade">
        <button v-if="selectedRows.length" class="btn btn-delete-red btn-primary-red"
            type="button"
            @click="handleDeleteItem">
            <span>Удалить выбранное</span>
        </button>
    </Transition>

    <Alert />

    <Transition name="fade">
        <v-progress-circular v-if="loading"
            :model-value="progress"
            :rotate="360"
            :size="65"
            :width="8"
        >
            <template v-slot:default> {{ progress }} % </template>
        </v-progress-circular>
    </Transition>

    <Transition name="fade">
        <FolderCreateModal v-if="addModalIsOpen"
            @closeFolderCreateModal="closeFolderCreateModal"
            @saveFolderCreateModal="addDir"
            :clients="clients"
            :brands="brands"
            :route_brand_search="route_brand_search" />
    </Transition>

    <Transition name="fade">
        <EditContentModal
            v-if="editContentModal"
            @invalidDuration="invalidDuration"
        />
    </Transition>

    <Transition name="fade">
        <EditFolderModal v-if="editFolderModal" />
    </Transition>

    <Transition name="fade">
        <ConfirmModal v-if="removeContentModal"
            :title="'Вы уверены, что хотите удалить выбранный контент?'"
            :confirmText="'Ок'"
            :confirmMethod="deleteItem"
            :cancelText="'Отмена'"
            @closeModal="hideConfirmModal(state)"
            @confirm="closeInfo"/>
    </Transition>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex/dist/vuex.cjs.js';

import { withPopper } from '../../../utilites.js';
import PaginationElement from '../../../elements/PaginationElement.vue'
import Content from '../../../models/Content'
import ChangePage from '../../../helpers/ChangePage'
import ContentPictureComponent from './Content/ContentPictureComponent.vue'
import EditContentModal from '../../../modals/EditContentModal.vue';
import EditFolderModal from '../../../modals/EditFolderModal.vue';
import FolderCreateModal from '../../../modals/FolderCreateModal.vue';
import Alert from '../../alerts/Alert.vue';
import ConfirmModal from '../../../modals/ConfirmModal.vue';

export default {
    name: "ContentComponent",

    components: {
        ContentPictureComponent,
        PaginationElement,
        Error,
        EditContentModal,
        EditFolderModal,
        FolderCreateModal,
        Alert,
        ConfirmModal
    },

    props: {
        route_create_page: String,
        route_edit_page: String,
        route_list: String,
        route_delete: String,
        route_delete_content_batch: String, // Роут для мультиудаления контента
        route_get: String,
        route_update: String,
        route_create_dir: String,
        route_client_search: String,
        route_brand_search: String,
        route_content_to_dir: String,
        route_content_to_dir_batch: String, // Роут для мультиперемещения контента
        route_dir_to_dir: String,
        route_dir_to_dir_batch: String, // Роут для мультиперемещения папок
        route_dir_content: String,
        route_dir_edit: String,
        route_dir_del: String,
        route_content_upload: String,
        domain: String,
        current_page: {
            type: Number,
            default: 1
        },
        client_id: {
            type: Number,
            default: 0
        }
    },

    data: function () {
        return {
            brands: [],
            directoryName: null,
            addModalIsOpen: false,
            moveModalIsOpen: false,
            content: new Content({
                route_list: this.route_list,
                route_delete: this.route_delete,
                route_get: this.route_get,
                route_create_dir: this.route_create_dir,
                route_client_search: this.route_client_search,
                route_brand_search: this.route_brand_search,
                route_content_to_dir: this.route_content_to_dir,
                route_content_to_dir_batch: this.route_content_to_dir_batch,
                route_dir_to_dir: this.route_dir_to_dir,
                route_dir_to_dir_batch: this.route_dir_to_dir_batch,
                route_dir_content: this.route_dir_content,
                route_dir_edit: this.route_dir_edit,
                route_dir_del: this.route_dir_del,
                route_content_upload: this.route_content_upload,
                route_update: this.route_update,
            }),
            search: '',
            searchTimer: null,
            clients: [],
            filter: {
                client_id: this.client_id,
                brand_id: null
            },
            count: 1,
            limit: 9999,
            rows: 0,
            page: this.current_page,
            item: {},
            showPic: false,
            alertMessage: '',
            loading: false,
            progress: 0,
            removeContentModal: false
        };
    },

    computed: {
        ...mapState('content', ['editFolderModal', 'editContentModal', 'editContentModal', 'items', 'selectedItem', 'selectedRows'])
    },

    watch: {
        search: {
            handler(newVal) {
                if (this.searchTimer) clearTimeout(this.searchTimer);
                this.searchTimer = setTimeout(() => {
                    this.loadItems();
                }, 1000);
                this.getSearchValue(newVal);
            }
        },

        filter: {
            handler() {
                this.loadItems();
                this.searchBrands();
            },
            deep: true
        },
        'filter.client_id'(newValue) {
            if (newValue !== null) {
                localStorage.setItem('client_id', newValue);
                if (this.brands.find(brand => brand.id === Number(localStorage.getItem('brand_id')))) {
                    this.filter.brand_id = null;
                    localStorage.removeItem('brand_id');
                }
            } else {
                this.filter.client_id = null;
                localStorage.removeItem('client_id');

                this.filter.brand_id = null;
                localStorage.removeItem('brand_id');
            }
        },
        'filter.brand_id'(newValue) {
            if (newValue !== null) {
                localStorage.setItem('brand_id', newValue);
            }
            else {
                this.filter.brand_id = null;
                localStorage.removeItem('brand_id');
            }
        },
    },

    methods: {
        ...mapMutations('content', ['showEditFolderModal', 'closeEditFolderModal', 'closeEditContentModal', 'getSearchValue', 'getRoutes', 'getLoadTableParams', 'getDeleteFolderRoute', 'getDeleteContentRoute', 'getEditFolderRoute', 'getEditContentRoute', 'updateContent', 'newDir', 'clearSelectedRows', 'showRemoveContentModal', 'hideRemoveContentModal', 'deselectItem']),
        ...mapMutations('alerts', ['addAlert']),
        ...mapMutations('ui', ['toggleLoading']),
        ...mapActions('content', ['loadItems', 'deleteItem']),

        withPopper,

        findElement(items, search, splice = false) {
            let finded = items.find((item) => (item.id == search.id && item.type == search.type));
            if (finded) {
                if (splice) {
                    let index = items.findIndex((item) => (item.id == search.id && item.type == search.type));
                    items.splice(index, 1);
                }
                return finded;
            }
            items.some((value, index) => {
                if (value.content && value.content.length > 0) {
                    finded = this.findElement(value.content, search, splice);
                    return finded;
                }
                return false;
            });
            return finded;
        },

        addContents: function () {
            if (this.selectedItem.type != 2) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Выберите папку для добавления контента!' });
                return;
            }
            this.$refs.file_upload.click();
        },

        fileUploads: async function (e) {
            if (this.selectedItem.type != 2) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Выберите папку для добавления контента!' });
                return;
            }

            this.loading = true;
            let fileList = Array.from(e.target.files);
            let summary = [];
            let success = [];
            let error = [];

            for (let file of fileList) {
                this.progress += Math.floor(100 / fileList.length);
                let formData = new FormData();
                formData.append('files[]', file);
                formData.append('group_id', this.selectedItem.id);

                let result = await this.content.uploadFiles(formData);
                summary.push({
                    status: result.status,
                    message: `${file.name} - ${result.message}.`
                });
            }

            this.progress = 100;
            setTimeout(() => {
                this.loading = false;
                this.progress = 0;
            }, 200);

            error = summary.filter(item => item.status !== 'ok');
            success = summary.filter(item => item.status === 'ok');

            this.alertMessage = `Загружено файлов: ${success.length} из ${fileList.length}.\n`;

            this.alertMessage += summary
                .filter(item => item.status !== "ok")
                .map(item => item.message).join('\n');

            if (error.length > 0 && success.length == 0) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: this.alertMessage });
            } else if (success.length > 0 && error.length == 0) {
                this.alertMessage = 'Файлы успешно загружены!'
                this.addAlert({ type: 'success', title: 'Успешно', text: this.alertMessage });
            } else {
                this.addAlert({ type: 'warning', title: 'Ошибка', text: this.alertMessage });
            }
            this.$refs.file_upload.value = null;
            this.loadItems(this.route_list);
        },

        async loadDir(item) {
            if (item.type == 2) {
                let result = await this.content.loadDir(item.id);
                item.content = result.items;
                return result;
            }
        },

        isDescendant(dir, target) {
            if (!dir?.content || dir.content.length === 0) return false;

            for (let child of dir.content) {
                if (child.id === target.id) {
                    return true;
                }
                // рекурсивно проверяем дальше
                if (this.isDescendant(child, target)) {
                    return true;
                }
            }
            return false;
        },

        // Множественное перемещение файлов / папок
        async contentToDir(items, targetContent) {
            this.selectedItem.id = 0;
            this.selectedItem.type = 0;

            let dirs = items.filter(item => item.type == 2); // папки
            let files = items.filter(item => item.type != 2); // файлы

            // Проверка файлов
            for (let file of files) {
                if (file.id === targetContent?.id) {
                    this.addAlert({ type: 'error', title: 'Ошибка', text: 'Нельзя перемещать файл в самого себя!' });
                    return;
                }
            }

            // Проверка папок (рекурсивно)
            for (let dir of dirs) {
                if (dir.id === targetContent?.id) {
                    this.addAlert({ type: 'error', title: 'Ошибка', text: 'Нельзя переместить папку саму в себя!' });
                    return;
                }
                if (this.isDescendant(dir, targetContent)) {
                    this.addAlert({ type: 'error', title: 'Ошибка', text: 'Нельзя перемещать папку в её дочернюю папку!' });
                    return;
                }
            }

            if (dirs.length) {
                let moveDir = await this.content.dirsToDir(targetContent.type === 2 ? targetContent.id : targetContent.group_id, dirs.map(d => d.id));
                if (moveDir.status === 'ok') {
                    this.loadItems(this.route_list);
                } else {
                    this.addAlert({ type: 'error', title: 'Ошибка', text: 'Контент можно перемещать только в рамках одного бренда!' });
                }
            }

            if (files.length) {
                let moveContent = await this.content.contentsToDir(targetContent.type === 2 ? targetContent.id : targetContent.group_id, files.map(f => f.id));
                if (moveContent.status === 'ok') {
                    this.loadItems(this.route_list);
                } else {
                    this.addAlert({ type: 'error', title: 'Ошибка', text: 'Контент можно перемещать только в рамках одного бренда!' });
                }
            }
        },

        addDir: async function (modal) {
            if (modal.directoryName.length >= 100) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Название папки не может быть длиннее 100 символов!' });
                this.toggleLoading();
                return;
            }

            if (modal.directoryName === null || modal.directoryName === '') {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Введите название папки!' });
                this.toggleLoading();
                return;
            }

            if (modal.client === null || modal.client === '') {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Выберите клиента!' });
                this.toggleLoading();
                return;
            }

            if (modal.brand === null || modal.brand === '') {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Выберите бренд!' });
                this.toggleLoading();
                return;
            }

            this.closeFolderCreateModal();

            let client_id = 0;

            if (this.client_id > 0) client_id = this.client_id;
            else if (modal.client.id > 0) client_id = modal.client.id;

            let parent_id = 0;

            if (this.selectedItem.type == 2) {
                parent_id = this.selectedItem.id;
            }

            let result = await this.content.createDir({
                client_id: client_id,
                parent_id: parent_id,
                brand_id: modal.brand.id,
                directory_name: modal.directoryName
            });

            result.item.brand = this.brands.find(brand => brand.id === result.item.brand_id).name;

            if (result.status === 'ok') {
                localStorage.setItem(`dir${parent_id}`, true);
                this.loadItems();
            } else {
                console.log('error: add_dir')
            }
        },

        pageChange: function (newPage) {
            this.page = newPage;
            this.loadItems(this.route_list);
        },

        closeModal: function () {
            this.showPic = false;
            this.item = {};
        },

        searchClients: async function () {
            let clients = await this.content.clients();
            this.clients = clients.items;
        },

        searchBrands: async function () {
            let brands = await this.content.brands({
                client_id: this.filter.client_id
            });
            this.brands = brands.items;
        },

        getClientID: function() {
            if (localStorage.getItem('client_id')) {
                this.filter.client_id = Number(localStorage.getItem('client_id'));
            } else {
                this.filter.client_id = null;
            }
        },

        getBrandID: function() {
            if (localStorage.getItem('brand_id')) {
                this.filter.brand_id = Number(localStorage.getItem('brand_id'));
            }
        },

        interceptResponse() {
            window.lastResponse = null;

            axios.interceptors.response.use(response => {
                window.lastResponse = response;
                return response;
            }, error => {
                window.lastResponse = error.response;
                return Promise.reject(error);
            });
        },

        closeInfo() {
            this.deselectItem();
            this.clearSelectedRows();
        },

        closeFolderCreateModal() {
            this.addModalIsOpen = false;
        },

        invalidDuration(data) {
            this.addAlert({ type: 'warning', title: 'Предупреждение', text: data });
            this.toggleLoading();
        },

        handleDeleteItem() {
            this.removeContentModal = true;
        },

        hideConfirmModal(state) {
            this.removeContentModal = state;
        }
    },

    mounted() {
        this.getLoadTableParams({ route: this.route_list, page: this.page, limit: this.limit, search: this.search, filter: this.filter });
        this.getRoutes( // Забираю роуты в store для использования в actions
            {
                deleteFolderRoute: this.route_dir_del ?? null,
                deleteContentRoute: this.route_delete ?? null,
                deleteContentBatch: this.route_delete_content_batch ?? null,
                editFolderRoute: this.route_dir_edit ?? null,
                editContentRoute: this.route_update ?? null
            }
        );
        this.interceptResponse();
        this.getClientID();
        this.getBrandID();
        this.searchClients();
        this.searchBrands();
    }
};
</script>

<style scoped>
    .content-btn-group {
        display: flex;
        gap: 12px;
    }
    .dropdown-menu {
        z-index: 9999;
    }
    .filter-cancel-btn {
        cursor: pointer;
        color: #354052;
        transition: 0.2s;
    }
    .filter-cancel-btn:hover {
        color: red;
        transition: 0.2s;
    }
    .filter-table__list {
        width: 103%;
        overflow: unset;
    }
    .filter-table__btns {
        margin: 0px 10px 0px 10px;
    }
    .filter-table__item {
        width: 227px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .vs-selected {
        width: 157px;
    }
    .vs__selected,
    .vs__dropdown-option {
        width: 175px;
        display: block;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
    .content-preview {
        display: none;
    }
    @media (max-width: 600px) {
        .filter-table__list {
            flex-direction: row;
        }
        .filter-table__item {
            width: 112px;
        }
        .vs-selected {
            width: 94px;
        }
        .vs__selected,
        .vs__dropdown-option {
            width: 112px;
        }
    }
</style>
